import React from 'react'
import { Box, RadioButtonWMO, Text } from '@usap/uicomponents'
import { Container, Heading, ListContainer, List, OptionText } from "../style/OptionsSelectItemsWMO.css"

const OptionsSelectItemsWMO = (props) => {
  const {
    widgets,
    setCheckedSelected,
    appSteps,
    primaryStep,
    stepHandler,
    errorSteps,
    selectedPartETA,
    selectedPart,
    optionsToHide,
    orderItems
  } = props

  // Halt rendering when warranty claim already selects an option
  if (appSteps.length > 0 && primaryStep === 'warrantyClaim') {
    return null
  }

  const requiredData = widgets.required
    ? ''
    : '<em style="font-size: 12px;font-weight: normal">(Optional)</em>'

  const headerText = `${widgets.title} ${requiredData}`
  const currDate = new Date()
  const currDays = currDate.getDate()
  const currMonth = currDate.getMonth() + 1
  const currYear = currDate.getFullYear()
  const todaysDate = `${currYear}-${currMonth}-${currDays}`
  const isPassedDate = new Date(selectedPartETA) >= new Date(todaysDate)
  const isMainReason = widgets.id === 'mainReason'

  if (isPassedDate && isMainReason) {
    let indexLoc = 0
    widgets.options.forEach(item => {
      if (item.id === 'lateDelivery') {
        widgets.options.splice(indexLoc, 1)
      }
      indexLoc += 1
    })
  }
  const displayMainBox = optionsToHide.includes(widgets.id) ? 'none' : 'flex'

  const selectedItem = orderItems?.length > 0 && orderItems.filter((item) => item.sku === selectedPart)?.[0]

  const selectedReasons = selectedItem ? selectedItem.reasons : []

  return (
    <Container id={widgets.id} style={{ display: displayMainBox }}>
      <Heading>
        {headerText}
      </Heading>

      {widgets.subtitle && (
        <Box alignContent="start" alignSelf="start">
          <Text size="small" margin={{ left: 'xsmall', bottom: 'small' }}>
            {widgets.subtitle}
          </Text>
        </Box>
      )}

      <Text id={`error-${widgets.id}`} style={{ color: '#f90000', fontSize: '12px' }}>
        {errorSteps[widgets.id]}
      </Text>

      <ListContainer>
        {widgets.options.filter(step => step.id !== 'lifetimeReplacement').map(({ id, label, value }) => {
          const isReasonSelected = selectedReasons.find((reason) => reason.id === id);

          return (<List
            key={`${widgets.id}-${value}`}
            id={`${widgets.id}-${value}`}
            className={`${widgets.id}-options`}
            style={{ 
              display: optionsToHide.includes(`${widgets.id}-${value}`) ? 'none' : 'flex',
              border: isReasonSelected ? '1.5px solid #282832' : "",
              padding: "13px"
            }}
          >
            <Box width="30px" alignContent="start" alignSelf="center">
              <RadioButtonWMO
                key={`${widgets.id}-${value}`}
                value={value}
                name={widgets.id}
                id={value}
                style={{ minWidth: 'unset' }}
                checked={setCheckedSelected(value)}
                custom
                onClick={() => stepHandler(widgets, value, label, selectedPart)}
              />
            </Box>
            <Box
              width="100%"
              alignContent="start"
              alignSelf="start"
              onClick={() => stepHandler(widgets, value, label, selectedPart)}
            >
              <OptionText>
                {label}
              </OptionText>
            </Box>
          </List>)
          })}
      </ListContainer>
    </Container>
  )
}

export default OptionsSelectItemsWMO
